import { render, staticRenderFns } from "./TableLazy.vue?vue&type=template&id=6b2a65e9&"
import script from "./TableLazy.vue?vue&type=script&lang=js&"
export * from "./TableLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports